import { render, staticRenderFns } from "./TvBoxAndroid.vue?vue&type=template&id=38be6a52&"
import script from "./TvBoxAndroid.vue?vue&type=script&lang=js&"
export * from "./TvBoxAndroid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports